const sendGAEvent = (name: string, params?: object) => {
	if (!window || typeof window === 'undefined') {
		return
	}

	window.gtag?.('event', name, params)
}
export default sendGAEvent
